(function() { window.GUID_ec5c0f12_7e78_43b3_8102_56a0d6d84f48 = { getGuid: function() { return "ec5c0f12-7e78-43b3-8102-56a0d6d84f48"; } }; })();
var CS;
(function (CS) {
    class ScrollListener {
        constructor(jqueryElement) {
            this.timerReset = null;
            this.lastScroll = 0;
            this.lastDirection = "";
            let me = this;
            me.$scrolledElement = jqueryElement;
            me.$scrolledElement.offon('scroll.scrolllistener', function (e) {
                if (me.OnScrollChange != null) {
                    me.OnScrollChange();
                }
            });
            me.$scrolledElement.offon('touchmove.scrolllistener', function (e) {
                if (me.OnScrollChange != null) {
                    me.OnScrollChange();
                }
            });
        }
        scrollChange() {
            if (this.OnScrollChange != null) {
                this.OnScrollChange();
            }
            this.testScrollDirectionChange();
        }
        testScrollDirectionChange() {
            let me = this;
            clearTimeout(me.timerReset);
            me.timerReset = setTimeout(function () {
                let currentScroll = me.$scrolledElement.scrollTop();
                let currentDirection = me.lastDirection;
                if (currentScroll > me.lastScroll && currentScroll > 50) {
                    currentDirection = "down";
                    if (me.OnScrollDirectionChange != null && currentDirection != me.lastDirection) {
                        me.OnScrollDirectionChange.call(this, "down");
                    }
                }
                else if (currentScroll < me.lastScroll) {
                    currentDirection = "up";
                    if (me.OnScrollDirectionChange != null && currentDirection != me.lastDirection) {
                        me.OnScrollDirectionChange.call(this, "up");
                    }
                }
                me.lastScroll = currentScroll;
                me.lastDirection = currentDirection;
            }, 0);
        }
    }
    CS.ScrollListener = ScrollListener;
})(CS || (CS = {}));

//# sourceMappingURL=scroll-listener.pre.js.map
